import { Link } from 'react-router-dom';

/**
 * LegalConsent — small reusable required-checkbox that links to Privacy + Terms.
 *
 * Usage:
 *   <LegalConsent
 *     checked={form.consent}
 *     onChange={(v) => setForm({ ...form, consent: v })}
 *     error={errors.consent}
 *     testId="contact-consent"
 *   />
 */
const LegalConsent = ({ checked, onChange, error, testId = 'legal-consent' }) => (
  <div className="mt-2">
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
        className="mt-1 w-5 h-5 rounded border-[#D8D2C8] text-[#4A641F] focus:ring-[#4A641F] shrink-0"
      />
      <span className="text-xs sm:text-sm text-[#3D512D] leading-7">
        أوافق على{' '}
        <Link
          to="/legal/privacy-policy"
          target="_blank"
          className="text-[#4A641F] hover:underline font-medium"
        >
          سياسة الخصوصية
        </Link>{' '}
        و{' '}
        <Link
          to="/legal/terms-conditions"
          target="_blank"
          className="text-[#4A641F] hover:underline font-medium"
        >
          الشروط والأحكام
        </Link>{' '}
        الخاصة بـ Child Horizons — آفاق الطفولة.
      </span>
    </label>
    {error && (
      <p className="text-red-500 text-xs mt-2 pe-8" data-testid={`${testId}-error`}>
        {error}
      </p>
    )}
  </div>
);

export default LegalConsent;
